<template>
  <div class="ui right aligned container">
    <button @click="addMenu" class="ui primary icon button">Add</button>

    <vuetable ref="vuetable" api-url="/menus/list" :fields="fields">
      <template scope="props" slot="actions">
        <i @click="editMenu(props.rowData)" class="edit link icon"></i>
        <i @click="deleteMenu(props.rowData)" class="red trash alternate outline link icon"></i>
      </template>
    </vuetable>

    <Modal v-model="modal">
      <template slot="title">
        {{title}}
      </template>
      <form class="ui form">
        <div class="required field">
          <label>标题</label>
          <input name="title" placeholder="标题" type="text" v-model="menu.title">
        </div>
        <div class="required field">
          <label>URL</label>
          <input name="url" placeholder="URL" type="url" v-model="menu.uri">
        </div>
        <div class="required field">
          <label>顺序</label>
          <input name="orderNumber" placeholder="顺序" type="number" v-model="menu.orderNumber">
        </div>
        <div class="required field">
          <label>父菜单</label>
          <input name="parentId" placeholder="父菜单" type="number" v-model="menu.parentId">
        </div>
        <div class="required field">
          <label>有效</label>
          <input name="enabled" placeholder="有效" type="checkbox" v-model="menu.enabled">
        </div>
      </form>
      <template slot="actions">
        <div @click="onCancel" class="ui cancel button">取消</div>
        <div @click="onSubmit" class="ui positive button">提交</div>
      </template>
    </Modal>

  </div>
</template>

<script>
  import axios from 'axios';
  import EventBus from '../../services/event-bus';
  import Vuetable from '../../table/Vuetable.vue';
  import Modal from "../../components/Modal";

  export default {
    name: "MenuAdmin",
    components: {
      Vuetable,
      Modal,
    },
    data() {
      return {
        modal: false,
        menu: {
          title: '',
          uri: '',
          orderNumber: 0,
          parentId: 0,
          enabled: true,
        },
        title: '添加',
        fields: [
          {name: 'id', title: 'ID'},
          {name: 'title', title: '标题'},
          {name: 'uri', title: 'URI'},
          {name: 'orderNumber', title: '顺序'},
          {name: 'parentId', title: '父菜单'},
          {name: 'enabled', title: '有效'},
          {name: '__slot:actions', title: ''}
        ],
      };
    },
    methods: {
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      editMenu(menu) {
        this.menu = {
          id: menu.id,
          title: menu.title,
          uri: menu.uri,
          orderNumber: menu.orderNumber,
          parentId: menu.parentId,
          enabled: menu.enabled,
        };
        this.title = '编辑';
        this.modal = true;
      },
      deleteMenu(menu) {
        axios.delete('/menus/' + menu.id).then(() => {
          this.refresh();
          EventBus.$emit('menus');
        }).catch((error) => {
          console.log(error);
        });
      },
      addMenu() {
        this.title = '添加';
        this.modal = true;
      },
      onCancel() {
        if (this.menu.id) {
          this.menu = {};
        }
        this.modal = false;
      },
      onSubmit() {
        if (!this.menu.title) {
          return;
        }
        let api = '/menus';
        if (this.menu.id) {
          api = '/menus/' + this.menu.id;
        }
        axios.post(api, this.menu).then(() => {
          this.menu = {};
          this.modal = false;
          this.refresh();
          EventBus.$emit('menus');
        }).catch((error) => {
          console.log(error);
        });
      },
    }
  };
</script>

<style scoped>

</style>
